<template>
  <div class="context-menu" ref="cm">
    <slot/>
  </div>
</template>

<script>
export default {
  methods: {
    open (e) {
      if (this.$store.state.openedContextMenuRef) this.close(this.$store.state.openedContextMenuRef)
      const menu = this.$refs.cm
      menu.style.left = e.pageX + 'px'
      menu.style.top = e.pageY + 'px'
      menu.style.display = 'block'
      e.preventDefault()
      e.stopPropagation()
      this.$store.commit('OPENED_CM_REF', this.$refs.cm)
    },

    close (m) {
      const menu = m || this.$refs.cm
      menu.style.display = 'none'
    }
  }
}
</script>

<style lang="scss">
.context-menu {
  @include boxShadow(5px, 10px, 10px, -11px, rgba(0, 0, 0, 0.75));
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2000;
  width: 150px;
  padding: 5px 0;
  background-color: white;
  border-radius: 7px;
}
</style>
